<template>
  <el-footer>
    <div class="bnav-list">
      <router-link target="_self" v-for="(vl,idx) in infoBottom" :key="idx"    :to="{path:vl.toUrl}">{{vl.name}}</router-link>
      <p>Copyright © 《中国企业家》杂志社有限责任公司 版权所有　互联网新闻信息服务许可证(10120190020) <a class="link_abc" target="_blank" href="http://beian.miit.gov.cn">京ICP备12023044号</a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202010699" class="link_abc" >京公网安备11010202010699</a></p>
      <p>举报电话：010-63581900  &nbsp &nbsp  &nbsp 举报邮箱：zgqyj@iceo.com.cn</p>
    </div>
    </el-footer>
</template>
<script>
export default{
    name:'bbottom',
    data () {
        return {
          msg: 'success',
          infoBottom:[
            {name:"版权声明",toUrl:"/info/statement"},
            {name:"关于我们",toUrl:"/info/aboutus"},
            {name:"加入我们",toUrl:"/info/joinus"},
            {name:"广告服务",toUrl:"/info/abinfo"},
            {name:"会议活动",toUrl:"/activity"},
            {name:"联系我们",toUrl:"/info/contact"},
            {name:"杂志订阅",toUrl:"/info/subscription"},
            {name:"友情链接",toUrl:"/info/link"},
          ]
        }
    }
}
</script>

<style scoped>
  .link_abc{
    font-size: 12px !important;
  }
  .bnav-list {
    width: 100%;
    background: #bd0c16;
    padding:30px 0px;
    text-align: center;
  }
    .bnav-list  a{
      margin:0px 10px;
      color:#fff;
      text-decoration:none;
      font-size:16px;
    }
  .bnav-list p{
    font-size:12px;
               color:#fff;
               padding:0px;
               margin:0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/bbottom.vue